import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { CollaborationButton, CollaborationsDetailsContainer, ProfileImage } from "./CollaborationDetailsStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import { UserContext } from "../../context/userContext";
import { CollaborationsContext } from "../../context/collaborationsContext";

import arrowBack from './../../utils/images/arrow_back.svg';
import avatar from './../../utils/images/avatar_fluincr.png';
import check from './../../utils/images/check_circle_darker.svg';
import star from './../../utils/images/star.svg';
import gift from './../../utils/images/gift_white.svg';
import chat from './../../utils/images/chat.svg';

import { getCollaborationById, getCollaborationItemsById, patchCollaboration, putCollaborationStatus } from "../../api/collaborationApi";
import { countdown, formatDateLocal, fromUTCtoLocal, newFormat, toUTCString } from "../../services/dateServices";
import { fill, formatNumber } from "../../services/generalSevices";

import ModalDispute from "../../components/ModalDispute/ModalDispute";
import ContentDetailsInfluencer from "../../components/ContentDetailsInfluencer/ContentDetailsInfluencer";
import ContentDetailsCompany from "../../components/ContentDetailsCompany/ContentDetailsCompany";
import ModalReceivedDispute from "../../components/ModalReceivedDispute/ModalReceivedDispute";
import Spinner from "../../components/Spinner/Spinner";
import Chat from "../../components/Chat/Chat";
import ModalScoreCollaboration from "../../components/ModalScoreCollaboration/ModalScoreCollaboration";
import ImageUploading from 'react-images-uploading';
import { postFileBase64 } from "../../api/fileApi";
import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import CollaborationContent from "./CollaborationContent";
import Select from 'react-select';
import { collaborationsStatusOptions } from "../../utils/constants/general";
import { LangContext } from "../../context/langContext";
import ModalCarousel from "../../components/ModalCarousel/ModalCarousel";
import { URLplatform } from "../../utils/constants/constants";


export default function CollaborationDetails() {

    const navigate = useNavigate();

    const intl = useIntl();
    const { locale } = useContext(LangContext);

    const { idCollaboration } = useParams();

    const { userToken, userType, uniqueName, account } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);

    const [activeIndex, setActiveIndex] = useState(0);
    const [contentType, setContentType] = useState('photo');

    const { collaborationNotificationCount, setCollaborationNotificationCount } = useState(CollaborationsContext);

    const [collaborationDetails, setCollaborationDetails] = useState({});
    const [timeLeft, setTimeLeft] = useState(0);
    const [collaborationStatus, setCollaborationStatus] = useState();
    const [collaborationItems, setCollaborationItems] = useState([]);

    const [showDispute, setShowDispute] = useState(false);
    const [showReceivedDispute, setShowReceivedDispute] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [showChat, setShowChat] = useState(false);

    const [imagesToSend, setImagesToSend] = useState([]);

    const [auxCollaborationTotalPrice, setAuxCollaborationTotalPrice] = useState(null);
    const [auxProductPrice, setAuxProductPrice] = useState(null);
    const [auxGiftValue, setAuxGiftValue] = useState(null);

    const isAdmin = sessionStorage.getItem('isAdmin');

    const [statusIndex, setStatusIndex] = useState();
    const [statusOptions, setStatusOptions] = useState(collaborationsStatusOptions);
    const [collaborationValue, setCollaborationValue] = useState();

    const [showCarousel, setShowCarousel] = useState(false);
    const [contentIndex, setContentIndex] = useState(0);

    useEffect(() => {
        if (userToken !== null) {
            getCollaborationById({ collaborationId: idCollaboration, token: userToken }).then((response) => {
                setIsLoading(false);
                if (response.message === 'error') {
                    navigate('/error')
                } else {
                    setCollaborationDetails(response)
                    setCollaborationStatus(response.status)
                    setStatusIndex(response.status - 1)
                    setCollaborationValue(statusOptions[response.status - 1])
                    getCollaborationItemsById({ collaborationId: response.id }).then((itemResponse) => {
                        setCollaborationItems(itemResponse)
                    })
                    if (response.status === 1) {
                        setTimeLeft(2);
                    }
                }
            })
        }
    }, [userToken])

    useEffect(() => {

        const statusUpdate = [];
        setStatusIndex(collaborationStatus - 1);
        setCollaborationValue(statusOptions[collaborationStatus - 1])
        statusOptions.map((status, index) => {
            if ((collaborationStatus === 1) && (index === 3 || index === 4)) {//Si solo seat pagada no puede entrar en espera ni ser cerrada
                statusUpdate.push({ ...status, isDisabled: true })
            } else if (collaborationStatus === 1 && userType === 'company' && (index === 2)) {//Si estoy con perfil de compañia no puedo declinarla
                statusUpdate.push({ ...status, isDisabled: true })
            } else if (collaborationStatus === 3 && (index < 3 || index === 4)) {//Si fue aceptada No puedo volver a declinada o pagada ni tampoco cerrarla
                statusUpdate.push({ ...status, isDisabled: true })
            } else if ((collaborationStatus === 4) && (index < 2)) {//Si esta en espera puedo volver a Aceptada y Cerrarla
                //Para que puedan Cerrar la colaboración
                statusUpdate.push({ ...status, isDisabled: true })
            } else if (collaborationStatus === 0 || collaborationStatus === 2 || collaborationStatus === 5) {//Si está Creada, Declinada o Cerrada y no puedo cambiar sus estado
                statusUpdate.push({ ...status, isDisabled: true })
            } else {
                statusUpdate.push({ ...status })
            }
        })
        setStatusOptions(statusUpdate);

    }, [collaborationStatus])




    useEffect(() => {
        setCollaborationItems([])
        if (userToken !== null) {
            getCollaborationItemsById({ collaborationId: idCollaboration }).then((itemResponse) => {
                setCollaborationItems(itemResponse)
                setIsLoading(false)
            })
        }
    }, [userToken, collaborationStatus])

    useEffect(() => {

        if (Object.keys(collaborationDetails).length > 0) {
            const auxCurrency = currency.symbol;
            getConvertCurrency({ amount: collaborationDetails.totalPrice }).then((amountResponse) => {
                //setAuxCollaborationTotalPrice(amountResponse[auxCurrency].toFixed(0))
                setAuxCollaborationTotalPrice(amountResponse[auxCurrency].toFixed(2))
            })
            getConvertCurrency({ amount: collaborationDetails.product.price.USD }).then((amountResponse) => {
                //setAuxProductPrice(amountResponse[auxCurrency].toFixed(0))
                setAuxProductPrice(amountResponse[auxCurrency].toFixed(2))
            })
            if (collaborationDetails.giftValue !== null) {
                getConvertCurrency({ amount: collaborationDetails.giftValue }).then((amountResponse) => {
                    //setAuxGiftValue(amountResponse[auxCurrency].toFixed(0))
                    setAuxGiftValue(amountResponse[auxCurrency].toFixed(2))
                })
            }
        }

    }, [currency, collaborationDetails])

    const handlerDecline = () => {
        setIsLoading(true)
        putCollaborationStatus({ collaborationId: idCollaboration, newStatus: 2, token: userToken }).then((response) => {

            if (response.status === 200) {
                setCollaborationStatus(2)
                const collaborationBody = {
                    readcompany: false
                }

                patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody }).then((response) => {
                    setIsLoading(false)
                })
            }
        })
    }


    const handlerAccept = () => {
        setIsLoading(true)
        putCollaborationStatus({ collaborationId: idCollaboration, newStatus: 3, token: userToken }).then((response) => {

            if (response.status === 200) {
                setCollaborationStatus(3);

                const collaborationBody = {
                    readcompany: false
                }

                patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody }).then((response) => {
                    setIsLoading(false)
                })
            }
        })
    }

    const adminChangeStatus = (newStatus) => {
        setIsLoading(true);
        if (newStatus === 4) {
            setIsLoading(false);
            setShowDispute(true);
        } else {
            putCollaborationStatus({ collaborationId: idCollaboration, newStatus: newStatus, token: userToken }).then((response) => {
                if (response.status === 200) {
                    setCollaborationStatus(newStatus);
                    const collaborationBody = {}

                    if (userType === 'influencer') {
                        collaborationBody.readcompany = false;
                    } else {
                        collaborationBody.readinfluencer = false;
                    }

                    patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody }).then((response) => {
                        setIsLoading(false)
                    })
                } else if (response.status === 409) {
                    setIsLoading(false);
                    window.alert("You don't have permissions to do that action")
                }
            })
        }

    }

    const onChange = (imageList, addUpdateIndex) => {

        setIsLoading(true);
        setImagesToSend(imageList);

        const imageBody = {
            base64File: imageList[0].data_url.split(',')[1],
            formatFile: imageList[0].file.type.split('/')[1],
            //address: `fluincr/${uniqueName}/collaboration`
            address: `fluincr/${account}/collaboration`
        }

        postFileBase64({ body: imageBody, token: userToken }).then((responseImage) => {
            const body = {
                cover: responseImage
            }
            if (responseImage.length > 0) {
                patchCollaboration({ collaborationId: idCollaboration, collaborationBody: body }).then((response) => {
                    setIsLoading(false)
                })
            } else {
                setIsLoading(false)
            }

        })

    }


    const selectStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap', width: '180px'

        }),
        menu: (styles) => ({
            ...styles, display: 'flex'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        }),
        menuList: (styles) => ({
            ...styles, width: '180px'
        })
    };

    return (
        <CollaborationsDetailsContainer>
            <hr />
            <div className="collaborationTop">
                <div className="goBack" onClick={() => navigate(-1)}>
                    <img src={arrowBack} alt="back" className="backIcon" />
                    <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
                </div>
                <p className="order"><FormattedMessage id="collaboration_details_text_1" defaultMessage="Orden" /> #{(collaborationDetails?.id !== undefined) && fill(collaborationDetails?.id, 8)}</p>

                {/* <p className="date">{formatDateLocal(new Date(collaborationDetails?.creation))}</p> */}

                {(collaborationDetails?.creation !== undefined) && (<p className="date">{/* {formatDateLocal(fromUTCtoLocal(collaborationDetails?.creation))} */}{newFormat(collaborationDetails?.creation)}</p>)}

            </div>

            <div className="collaborationHeader">
                {(userType === 'influencer') ? (<div className="influencerDate">
                    <p className="influencerName"><FormattedMessage id="collaboration_details_text_2" defaultMessage="Colaboración con" /> <span>{collaborationDetails?.company?.nameCompany}</span>  </p>

                    <a href={`${URLplatform}/${collaborationDetails?.company?.username}`}>
                        <ProfileImage image={(collaborationDetails?.company?.imageProfile !== '' && collaborationDetails?.company?.imageProfile !== null) ? collaborationDetails?.company?.imageProfile : avatar} />
                    </a>


                    {(collaborationDetails?.company?.attributes?.verified) && (<img src={check} alt="check" className="check" />)}

                    <div className="rating">
                        <p className="score">{(collaborationDetails?.company?.rating === null) ? 'N/R' : collaborationDetails?.company?.rating}</p>
                        <img src={star} alt="star" className="star" />
                    </div>
                </div>) : (<div className="influencerDate">
                    <p className="influencerName"><FormattedMessage id="collaboration_details_text_2" defaultMessage="Colaboración con" /> <span>{collaborationDetails?.influincr?.givenName}</span>  </p>

                    <a href={`${URLplatform}/${collaborationDetails?.influincr?.username}`}>
                        <ProfileImage image={(collaborationDetails?.influincr?.imageProfile !== '' && collaborationDetails?.influincr?.imageProfile !== null) ? collaborationDetails?.influincr?.imageProfile : avatar} />
                    </a>

                    {(collaborationDetails?.influincr?.attributes?.verified) && (<img src={check} alt="check" className="check" />)}

                    <div className="rating">
                        <p className="score">{(collaborationDetails?.influincr?.rating === null) ? 'N/R' : collaborationDetails?.influincr?.rating}</p>
                        <img src={star} alt="star" className="star" />
                    </div>
                </div>)}

                <div className="collaborationStatus">

                    <div>
                        {(collaborationStatus === 1) && (<p className="countdown">{countdown({ date: collaborationDetails?.creation, days: timeLeft })}</p>)}

                        {(userType === 'influencer' && collaborationStatus === 1 && JSON.parse(isAdmin) !== true) && (<p className="declineButton" onClick={handlerDecline}><FormattedMessage id="collaboration_details_button_3" defaultMessage="Declinar" /></p>)}

                        {(collaborationStatus === 3) && (<p className="declineButton" onClick={() => { setShowDispute(true) }}><FormattedMessage id="collaboration_details_button_5" defaultMessage="Disputa" /></p>)}

                    </div>

                    {(userType === 'influencer' && JSON.parse(isAdmin) !== true) ? (<CollaborationButton status={collaborationStatus} disabled=

                        {collaborationStatus !== 1} onClick={handlerAccept}>
                        {(collaborationStatus === 1) ? (<FormattedMessage id="collaboration_details_button_2_influencer_1" defaultMessage="Aceptar" />) : ((collaborationStatus === 2) ? (<FormattedMessage id="collaboration_details_button_2_influencer_2" defaultMessage="Declinado" />) : (collaborationStatus === 3) ? (<FormattedMessage id="collaboration_details_button_2_influencer_3" defaultMessage="Aceptado" />) : (collaborationStatus === 4) ? (<FormattedMessage id="collaboration_details_button_2_influencer_4" defaultMessage="En espera" />) : (<FormattedMessage id="collaboration_details_button_2_influencer_5" defaultMessage="Cerrado" />))} {formatNumber(auxCollaborationTotalPrice)}
                        {/* <span style={{ fontSize: '0.8rem', marginLeft: '5px' }}>{currency.symbol}</span> */}
                        {/* {collaborationDetails?.totalPrice} */}
                        {(collaborationDetails?.giftValue !== null) && (<div className="giftContainer">
                            <div className="giftIconContainer">
                                <span>+</span>
                                <img src={gift} alt="gift" className="giftIcon" />
                            </div>
                            <span className="giftPrice"> {(collaborationDetails?.giftValue !== null) ? formatNumber(auxGiftValue) : '0.00'}</span>
                        </div>)}


                    </CollaborationButton>) : (userType === 'company' && JSON.parse(isAdmin) !== true) ?

                        (<CollaborationButton >
                            {(collaborationStatus === 1) ? (<FormattedMessage id="collaboration_details_button_2_company_1" defaultMessage="Aceptación pendiente" />) : ((collaborationStatus === 2) ? (<FormattedMessage id="collaboration_details_button_2_company_2" defaultMessage="Declinado" />) : (collaborationStatus === 3) ? (<FormattedMessage id="collaboration_details_button_2_company_3" defaultMessage="Aceptado" />) : (collaborationStatus === 4) ? (<FormattedMessage id="collaboration_details_button_2_company_4" defaultMessage="En espera" />) : (<FormattedMessage id="collaboration_details_button_2_company_5" defaultMessage="Cerrado" />))} {formatNumber(auxCollaborationTotalPrice)} {/* {collaborationDetails?.totalPrice} */}
                            {(collaborationDetails?.giftValue !== null) && (<div className="giftContainer">
                                <div className="giftIconContainer">
                                    <span>+</span>
                                    <img src={gift} alt="gift" className="giftIcon" />
                                </div>
                                <span className="giftPrice"> {(collaborationDetails?.giftValue !== null) ? formatNumber(auxGiftValue) : '0,00'}</span>
                            </div>)}

                        </CollaborationButton>) : <></>}


                    {(collaborationStatus !== undefined && statusIndex !== undefined && JSON.parse(isAdmin) === true) && (<div className="selectContainer">
                        <Select options={statusOptions}
                            styles={selectStyles}
                            placeholder={intl.formatMessage({ id: "collaboracion_status_title" })}
                            //defaultValue={statusOptions[statusIndex]}
                            value={collaborationValue}
                            onChange={(event) => {
                                adminChangeStatus(event.value);
                            }} />
                    </div>)}

                </div>
            </div>

            {(userType === 'company' && collaborationStatus === 3 && auxGiftValue !== null) && (<div className="trackingContainer">
                {/* <div className="trackingData">
                    <p><FormattedMessage id="collaboration_details_traking_title" defaultMessage="Número de seguimiento del producto/servicio" /></p>
                    <input type="text" className="inputTracking" placeholder={intl.formatMessage({ id: "collaboration_details_traking_input" })} />
                    <div className="buttonsContainer">
                        <button className="editButton"><FormattedMessage id="collaboration_details_traking_button_edit" defaultMessage="Editar" /></button>
                        <button className="saveButton"><FormattedMessage id="collaboration_details_traking_button_save" defaultMessage="Guardar" /></button>
                    </div>
                </div> */}
                <div className="influencerData">
                    <p><FormattedMessage id="collaboration_details_traking_text_1" defaultMessage="Destinatario" />: <span className="influencerName">{collaborationDetails.influincr.givenName} {collaborationDetails.influincr.familyName}</span></p>
                    <p><FormattedMessage id="collaboration_details_traking_text_2" defaultMessage="Dirección" />:
                        <span> {collaborationDetails.influincr.address}</span>
                        <span>{(collaborationDetails.influincr.city !== null || collaborationDetails.influincr.city !== '') && (`, ${collaborationDetails.influincr.city}`)}</span>
                        <span>{(collaborationDetails.influincr.country) && (`-${(locale === 'es-CO') ? (collaborationDetails.influincr.country.nombre) : (collaborationDetails.influincr.country.name)}`)}</span></p>
                    <p><FormattedMessage id="collaboration_details_traking_text_3" defaultMessage="Código postal" />:  <span>{collaborationDetails.influincr.attributes?.zipcode}</span></p>
                </div>
            </div>)}

            <div className="collaborationBody">
                <section>
                    <div className="productInformation">
                        <div className="productContainer">
                            <div className="productImage" style={{ backgroundImage: `url(${collaborationDetails?.product?.image})` }}>

                            </div>
                            <div className="description">
                                <p className="productName">{collaborationDetails?.product?.name}</p>
                                <p className="productPrice">$ {/* {collaborationDetails?.product?.price?.USD} */}{formatNumber(auxProductPrice)}</p>
                                <p className="productDescription">{collaborationDetails.product?.description}</p>
                            </div>
                        </div>

                        <div className="collaborationStatusMobile">

                            {(userType === 'influencer' && JSON.parse(isAdmin) !== true) ? (<CollaborationButton status={collaborationStatus} disabled={collaborationStatus !== 1} onClick={handlerAccept}>
                                {(collaborationStatus === 1) ? (<FormattedMessage id="collaboration_details_button_2_influencer_1" defaultMessage="Aceptar" />) : ((collaborationStatus === 2) ? (<FormattedMessage id="collaboration_details_button_2_influencer_2" defaultMessage="Declinado" />) : (collaborationStatus === 3) ? (<FormattedMessage id="collaboration_details_button_2_influencer_3" defaultMessage="Aceptado" />) : (collaborationStatus === 4) ? (<FormattedMessage id="collaboration_details_button_2_influencer_4" defaultMessage="En espera" />) : (<FormattedMessage id="collaboration_details_button_2_influencer_5" defaultMessage="Cerrado" />))} {formatNumber(auxCollaborationTotalPrice)} {/* {collaborationDetails?.totalPrice} */}
                                {(collaborationDetails?.giftValue !== null) && (<div className="giftContainer">
                                    <div className="giftIconContainer">
                                        <span>+</span>
                                        <img src={gift} alt="gift" className="giftIcon" />

                                    </div>
                                    <span className="giftPrice"> {(collaborationDetails?.giftValue !== null) ? (formatNumber(auxGiftValue)) : '0,00'}</span>
                                </div>)}

                            </CollaborationButton>) : (userType === 'company' && JSON.parse(isAdmin) !== true) ?

                                (<CollaborationButton >
                                    {(collaborationStatus === 1) ? (<FormattedMessage id="collaboration_details_button_2_company_1" defaultMessage="Aceptación pendiente" />) : ((collaborationStatus === 2) ? (<FormattedMessage id="collaboration_details_button_2_company_2" defaultMessage="Declinado" />) : (collaborationStatus === 3) ? (<FormattedMessage id="collaboration_details_button_2_company_3" defaultMessage="Aceptado" />) : (collaborationStatus === 4) ? (<FormattedMessage id="collaboration_details_button_2_company_4" defaultMessage="En espera" />) : (<FormattedMessage id="collaboration_details_button_2_company_5" defaultMessage="Cerrado" />))} {formatNumber(auxCollaborationTotalPrice)} {/* {collaborationDetails?.totalPrice} */}
                                    {(collaborationDetails?.giftValue !== null) && (<div className="giftContainer">
                                        <div className="giftIconContainer">
                                            <span>+</span>
                                            <img src={gift} alt="gift" className="giftIcon" />
                                        </div>
                                        <span className="giftPrice"> {(collaborationDetails?.giftValue !== null) ? formatNumber(auxGiftValue) : '0,00'}</span>
                                    </div>)}

                                </CollaborationButton>) : <></>}

                            {(collaborationStatus !== undefined && JSON.parse(isAdmin) === true) && (<div className="selectContainer">
                                <Select options={statusOptions}
                                    styles={selectStyles}
                                    placeholder={intl.formatMessage({ id: "collaboracion_status_title" })}
                                    //defaultValue={statusOptions[statusIndex]}
                                    value={collaborationValue}
                                    onChange={(event) => {
                                        adminChangeStatus(event.value);
                                    }} />
                            </div>)}

                            <div>
                                {(collaborationStatus === 1) && (<p className="countdown">{countdown({ date: collaborationDetails?.creation, days: timeLeft })}</p>)}

                                {(userType === 'influencer' && collaborationStatus === 1 && JSON.parse(isAdmin) !== true) && (<p className="declineButton" onClick={handlerDecline}><FormattedMessage id="collaboration_details_button_3" defaultMessage="Declinar" /></p>)}

                                {(collaborationStatus > 2) && (<p className="declineButton" onClick={() => { setShowDispute(true) }}><FormattedMessage id="collaboration_details_button_5" defaultMessage="Disputa" /></p>)}
                            </div>
                        </div>
                    </div>

                    {(collaborationDetails?.comment !== '') && (<>
                        <p className="commentsTitle"><FormattedMessage id="collaboration_details_text_6" defaultMessage="Comentarios (ver detalladamente)" /></p>
                        <p className="comments">{collaborationDetails?.comment}</p>
                    </>)}

                    {(collaborationDetails.document !== '') && (
                        <a href={collaborationDetails.document} download={collaborationDetails.document} >
                            <p className="file"><FormattedMessage id="collaboration_details_text_12" defaultMessage="Collaborationfile" /></p>
                        </a>)}

                    {(userType === 'influencer') &&
                        (<ImageUploading
                            value={imagesToSend}
                            onChange={onChange}
                            maxNumber={1}
                            dataURLKey="data_url"
                        >
                            {({
                                imageList,
                                onImageUpload,
                                isDragging,
                                dragProps,
                            }) => (
                                <div className="upload__image-wrapper">
                                    <button type='button'
                                        onClick={onImageUpload}
                                        {...dragProps}
                                        className="imageUploadButton"
                                    >
                                        <p className="verified"><FormattedMessage id="collaboration_details_text_11" defaultMessage="Agregar Portada" /></p>
                                    </button>
                                </div>
                            )}
                        </ImageUploading>

                        )}

                    {/* {(userType === 'company') &&
                        (<p className="verified"><FormattedMessage id="collaboration_details_text_10" defaultMessage="Verificar Portada" /></p>)} */}

                    {(userType === 'influencer' && (collaborationStatus > 2)) &&
                        (<p className="voucher" onClick={() => { navigate('voucher') }}><FormattedMessage id="collaboration_details_text_14" defaultMessage="Ver voucher" /></p>)}


                    {(userType === 'company' && (collaborationStatus > 2)) && (<p className="voucher" onClick={() => { navigate('invoice') }}><FormattedMessage id="collaboration_details_text_13" defaultMessage="Ver factura" /></p>)}

                </section>
                <section>

                    <table>
                        {(collaborationItems) && (collaborationItems.map((item, index) => {
                            return (<CollaborationContent item={item} setShowDispute={setShowDispute} key={index} setActiveIndex={setActiveIndex} setShowCarousel={setShowCarousel} setContentIndex={setContentIndex} contentIndex={index} setContentType={setContentType} />
                            )
                        }))}

                    </table>

                </section>

            </div>
            <button className={`${(collaborationStatus !== 3) && 'disabled'} chatButton`} onClick={() => setShowChat(!showChat)} disabled={collaborationStatus !== 3}>
                <FormattedMessage id="collaboration_details_button_4" defaultMessage="Chat" />
                <img src={chat} alt="chat" className="chatIcon" />
            </button>

            {(showDispute) && (<ModalDispute setShowDispute={setShowDispute} collaborationDetails={collaborationDetails} setCollaborationStatus={setCollaborationStatus} setShowReceivedDispute={setShowReceivedDispute} />)}

            {(showReceivedDispute) && (<ModalReceivedDispute setShowReceivedDispute={setShowReceivedDispute} />)}

            {(isLoading) && (<Spinner />)}

            {(showChat) && (<Chat setShowChat={setShowChat} collaborationDetails={collaborationDetails} />)}

            {(showCarousel) && (<ModalCarousel setShowModalCarousel={setShowCarousel} content={collaborationItems[contentIndex]?.data.filter(element => !element.includes("empty"))} activeIndex={activeIndex} page='collaborationDetails' contentType={contentType} />)}

        </CollaborationsDetailsContainer>
    )
}